import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModalModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CronJobService } from '../../core/services/cron-job.service';
import { ToastService } from '../../core/services/toast.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';

@Component({
  selector: 'app-cron-job',
  templateUrl: './cron-job.component.html',
  styleUrl: './cron-job.component.scss'
})
export class CronJobComponent implements OnInit {
  loading = false;
  cronJobs: any[] = [];
  cronJobForm!: FormGroup;
  modalRef: NgbModalRef | null = null;
  editingId: string | null = null;
  isEditMode = false;

  breadCrumbItems: Array<{}>;

  constructor(
    private fb: FormBuilder,
    private cronJobService: CronJobService,
    private modalService: NgbModal,
    private toastService: ToastService,
      private confirmModalService: ConfirmModalService

  ) {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Cron Jobs', active: true }];
  }

  initForm() {
    this.cronJobForm = this.fb.group({
      name: ['', Validators.required],
      url: ['', Validators.required],
      method: ['POST', Validators.required],
      schedule: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.initForm();
    this.loadCronJobs();
  }

 loadCronJobs(): void {
  this.loading = true;

  this.cronJobService.getCronJobs().subscribe({
    next: (jobs) => {
      this.cronJobs = jobs;
      this.loading = false;
    },
    error: (err) => {
      this.loading = false;
      console.error('Error loading cron jobs', err);
    }
  });
}

  onSubmit(): void {
    if (this.cronJobForm.valid) {
      const cronJob: any = this.cronJobForm.value;
      console.log(this.isEditMode, this.editingId)
      if (this.isEditMode && this.editingId) {
        this.cronJobService.updateCronJob(this.editingId, cronJob).subscribe({
          next: () => {
            this.loadCronJobs();
            this.toastService.showToaster("Success", "Cron job updated successfully!", "success");
            if (this.modalRef) this.modalRef.close();
          },
          error: (err) => {
            console.error('Error updating cron job', err);
          }
        });
      } else {
        this.cronJobService.createCronJob(cronJob).subscribe({
          next: () => {
            this.loadCronJobs();
            this.toastService.showToaster("Success", "Cron job created successfully!", "success");
            if (this.modalRef) this.modalRef.close();
          },
          error: (err) => {
            console.error('Error creating cron job', err);
          }
        });
      }
    } else {
      this.toastService.showToaster("Validation", "Please fill all required fields", "info");
    }
  }

  openCreateModal(content: any) {
    this.isEditMode = false;
    this.editingId = null;
    this.cronJobForm.reset({ method: 'POST' });
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  openEditModal(job: any, content: any) {
    this.isEditMode = true;
    this.editingId = job?._id;
    this.cronJobForm.patchValue(job);
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  deleteCronJob(id: string): void {
  this.confirmModalService.open(
    'Delete Cron Job',
    'Are you sure you want to delete this cron job?',
    () => {
      this.confirmDeleteCronJob(id);
    },
    'Delete',
    'Cancel'
  );
}

confirmDeleteCronJob(id: string): void {
  this.loading = true;

  this.cronJobService.deleteCronJob(id).subscribe({
    next: () => {
      this.loading = false;

      this.loadCronJobs();

      this.toastService.showToaster(
        'Success',
        'Cron job deleted successfully!',
        'success'
      );
    },
    error: (err) => {
      this.loading = false;

      console.error('Error deleting cron job', err);
    }
  });
}
}
